import React, { FunctionComponent, useState } from "react";
import { useDispatch } from "react-redux";

import AuthFlowLayout from "../../layouts/AuthFlowLayout";
import BrandAuthLayout from "../../layouts/BrandAuthLayout";
import NewPasswordRequiredForm from "./components/NewPasswordRequiredForm";
import RedesignedSignInForm from "./components/RedesignedSignInForm";
import SignInForm from "./components/SignInForm";
import { CognitoAuthChallenge } from "../../utils/cognitoAuthChallenge";
import { setIsAuthLoading } from "../../redux/reducers/session";

const useNewDesign = process.env.REACT_APP_FEATURE_NEW_DESIGN === "true";

type AuthStep = "signIn" | CognitoAuthChallenge;

const SignInPage: FunctionComponent = () => {
  const dispatch = useDispatch();
  const [authStep, setAuthStep] = useState<AuthStep>("signIn");
  const [cognitoUser, setCognitoUser] = useState<any>(null);

  const handleChallenge = (user: any, challenge: CognitoAuthChallenge) => {
    dispatch(setIsAuthLoading(false));
    setCognitoUser(user);
    setAuthStep(challenge);
  };

  const renderAuthContent = () => {
    if (authStep === "NEW_PASSWORD_REQUIRED") {
      return <NewPasswordRequiredForm authUser={cognitoUser} onChallenge={handleChallenge} />;
    }

    if (useNewDesign) {
      return <RedesignedSignInForm onChallenge={handleChallenge} />;
    }

    return <SignInForm onChallenge={handleChallenge} />;
  };

  const layoutHeading = "Welcome Back";
  const layoutDescription = "Log in: to view your personalized dashboard, campaigns, and audiences.";

  if (useNewDesign) {
    return (
      <BrandAuthLayout heading={layoutHeading} description={layoutDescription}>
        {renderAuthContent()}
      </BrandAuthLayout>
    );
  }

  return (
    <AuthFlowLayout heading={layoutHeading} description={layoutDescription}>
      {renderAuthContent()}
    </AuthFlowLayout>
  );
};

export default SignInPage;
